import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutes, LegalRoutes, ProfileRoutes } from '@core';
import { isAdminGuard, isAuthedGuard } from '@auth';
import { BlockedVersionPage, UpdateGuard } from '@update';
import { LanguagePickerPage } from './lang/language-picker.page';
import { LegalPrivacyPage } from './legal/legal-privacy.page';
import { LegalTermsPage } from './legal/legal-terms.page';
import { ProfilePage } from './profile/profile.page';
import { ProfileEditPage } from './profile/profile-edit.page';
import { ContactPage } from './profile/contact/contact.page';
import { WhatsNewPage } from './profile/whats-new/whats-new.page';
import { PartnersPage } from './partners/partners.page';
import { PartnerDetailPage } from './partners/partner-detail.page';

const routes: Routes = [
  { path: AppRoutes.ROOT, redirectTo: AppRoutes.TODAY, pathMatch: 'full' },
  {
    path: AppRoutes.AUTH,
    canActivate: [UpdateGuard],
    loadChildren: () => import('@auth').then((m: typeof import('@auth')) => m.AuthModule)
  },
  {
    path: AppRoutes.TODAY,
    canActivate: [isAuthedGuard, UpdateGuard],
    loadChildren: () => import('@today').then((m: typeof import('@today')) => m.TodayModule)
  },
  {
    path: AppRoutes.DRILLS,
    canActivate: [isAuthedGuard, UpdateGuard],
    loadChildren: () => import('@drills').then((m: typeof import('@drills')) => m.DrillsModule)
  },
  {
    path: AppRoutes.PROGRESS,
    canActivate: [isAuthedGuard, UpdateGuard],
    loadChildren: () => import('@progress').then((m: typeof import('@progress')) => m.ProgressModule)
  },
  {
    path: AppRoutes.PLAN,
    canActivate: [isAuthedGuard, UpdateGuard],
    loadChildren: () => import('@plan').then((m: typeof import('@plan')) => m.PlanModule)
  },
  {
    path: AppRoutes.SESSION,
    canActivate: [isAuthedGuard, UpdateGuard],
    loadChildren: () => import('@session').then((m: typeof import('@session')) => m.SessionModule)
  },
  {
    path: AppRoutes.PLAYGROUND,
    loadComponent: () =>
      import('./playground/playground.component').then(
        (m: typeof import('./playground/playground.component')) => m.PlaygroundComponent
      )
  },
  {
    path: AppRoutes.LEGAL,
    children: [
      { path: LegalRoutes.PRIVACY, component: LegalPrivacyPage },
      { path: LegalRoutes.TERMS, component: LegalTermsPage },
      { path: '', redirectTo: LegalRoutes.PRIVACY, pathMatch: 'full' }
    ]
  },
  {
    path: AppRoutes.PROFILE,
    canActivate: [isAuthedGuard, UpdateGuard],
    children: [
      { path: '', component: ProfilePage, pathMatch: 'full' },
      { path: ProfileRoutes.EDIT, component: ProfileEditPage },
      { path: ProfileRoutes.CONTACT, component: ContactPage },
      { path: ProfileRoutes.WHATS_NEW, component: WhatsNewPage }
    ]
  },
  {
    path: AppRoutes.PARTNERS,
    canActivate: [isAuthedGuard, UpdateGuard],
    children: [
      { path: '', component: PartnersPage, pathMatch: 'full' },
      { path: ':id', component: PartnerDetailPage }
    ]
  },
  {
    path: AppRoutes.ADMIN,
    canActivate: [isAuthedGuard, isAdminGuard, UpdateGuard],
    loadChildren: () => import('@admin').then((m: typeof import('@admin')) => m.AdminModule)
  },
  {
    path: AppRoutes.AMMO,
    canActivate: [isAuthedGuard, UpdateGuard],
    loadChildren: () => import('@ammo').then((m: typeof import('@ammo')) => m.AmmoModule)
  },
  { path: AppRoutes.LANG, component: LanguagePickerPage },
  { path: AppRoutes.BLOCKED_VERSION, component: BlockedVersionPage },
  { path: '**', redirectTo: AppRoutes.DRILLS }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
